import { PREDEFINED_USER_ROLES, ROLE_PERMISSIONS } from '../../common/constants';
import { MY_DAY_TICKET_SCOPE } from '../scenes/myDay/useMyDayMode';

/**
 * Which app areas the user may open from the side menu and the Home tools
 * grid. Same rules for both so a tile never offers a page the menu hides.
 */
export const getMenuAccess = ({
	user,
	isAVC,
	isDriver,
	isPicker,
	canCompleteAssignedMarketSetups,
	ticketScope,
}) => {
	const hasRolePermission = permission => Boolean(user && (user.isSuperAdmin || user.role.permissions.includes(permission)));
	const isAdminUser = Boolean(user && (user.isSuperAdmin || (isAVC && user.role.name === PREDEFINED_USER_ROLES.ADMIN)));
	// Barcode scanner restricted to AVC admin role (SuperAdmin always allowed)
	const canScanProducts = isAdminUser;
	const canManageStocktakes = canScanProducts;
	const canViewStockDeliveries = isAdminUser && hasRolePermission(ROLE_PERMISSIONS.VIEW_STOCK_DELIVERY_LIST_PAGE);
	// Pickers process AVC driver returns, but other stock tools remain restricted to admins.
	const canViewPendingStock = Boolean(hasRolePermission(ROLE_PERMISSIONS.VIEW_STOCK_PAGE) || isPicker);
	const canViewPurchaseOrders = hasRolePermission(ROLE_PERMISSIONS.VIEW_PURCHASE_ORDER_LIST_PAGE);

	return {
		canViewServiceRuns: hasRolePermission(ROLE_PERMISSIONS.VIEW_SERVICE_RUN_LIST_PAGE),
		canAddServiceRuns: hasRolePermission(ROLE_PERMISSIONS.ADD_EDIT_SERVICE_RUNS),
		canViewWarehouseMenu: Boolean(canScanProducts || canManageStocktakes || canViewPendingStock || canViewStockDeliveries || canViewPurchaseOrders),
		canViewTicketList: ticketScope === MY_DAY_TICKET_SCOPE.DRIVER || hasRolePermission(ROLE_PERMISSIONS.VIEW_TICKET_LIST_PAGE),
		canApproveChecklists: hasRolePermission(ROLE_PERMISSIONS.APPROVE_CHECKLIST_SUBMISSIONS),
		canViewPointsOfSale: isAdminUser,
		canViewSetups: Boolean(isAdminUser || isDriver || canCompleteAssignedMarketSetups),
		canViewClockPass: Boolean(isAVC),
		canViewRoster: Boolean(isAVC),
		canViewProcedures: Boolean(isAVC),
		// Practical checklist training is an AVC People feature. The group Responsible person
		// completes sign-off in the field; employees can still check signed-off history.
		canViewTrainings: Boolean(isAVC),
	};
};
